import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from 'src/app/app-component-base';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import {
    MedicamentoResponse,
    PatientMedicationCreateCommand,
    PatientMedicationGetByIdQuery,
    PatientMedicationResponse,
    PatientsServiceProxy
} from '../../../../shared/service-proxies/service-proxies';
import { DateTimeService } from '../../../../shared/services/datetime.service';
import { BusquedaMedicamentosGridComponent } from '../../../_components/consultas/medicamentos/busquedamedicamentos-grid.component';

@Component({
    templateUrl: './editpatientmedications.component.html'
})
export class EditPatientMedicationsComponent extends AppComponentBase implements OnInit {

    form: FormGroup;

    id?: number = null;
    patient?: number = null;
    birthDate?: Date = null;
    model: PatientMedicationResponse;

    medicamentoSeleccionado: MedicamentoResponse;

    blockedDocument = false;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private service: PatientsServiceProxy,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig,
        private dateTimeService: DateTimeService
    ) {
        super(injector);
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    ngOnInit() {
        const self = this;

        self.prepareForm();

        // Si hay un id, buscar el registro correspondiente
        self.id = self.modalConfig.data.id;
        self.patient = self.modalConfig.data.patient;

        if (self.id) {
            self.getForEdit();
        }
    }

    getForEdit(): void {
        const self = this;

        const req = new PatientMedicationGetByIdQuery();
        req.id = self.id;

        self.service.getPatientMedicationById(req)
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {
                self.model = data;

                // self.f.codigoMedicamento.setValue(data.codigoMedicamento);
                self.f.medicamentoDesc.setValue(data.codigoMedicamento + ' - ' + data.medicamentoDesc);
                self.f.periodo.setValue(data.periodo);
                self.f.fechaInicio.setValue(self.dateTimeService.getDateToAssignInFormControl(data.fechaInicio));
                self.f.fechaFin.setValue(self.dateTimeService.getDateToAssignInFormControl(data.fechaFin));
                self.f.observaciones.setValue(data.observaciones);

                self.f.periodo.disable();
                self.f.fechaInicio.disable();
                self.f.fechaFin.disable();
                self.f.observaciones.disable();
            });
    }

    buscarMedicamentos(): void {
        const self = this;

        const ref = self.dialogService.open(BusquedaMedicamentosGridComponent, {
            styleClass: 'd-sm d-md-65 d-lg-70 d-xl-50',
            header: self.l('Busquedas.Medicamentos'),
            showHeader: true,
            dismissableMask: false,
            data: {

            }
        });

        ref.onClose.subscribe((p: MedicamentoResponse) => {

            console.log(p);

            if (p) {
                self.medicamentoSeleccionado = p;
                // self.f.codigoMedicamento.setValue(p.codigoMedicamento);
                self.f.medicamentoDesc.setValue(p.codigoMedicamento + ' - ' + p.descripcion);
            }
        });
    }

    save(): void {
        const self = this;

        const createCmd = new PatientMedicationCreateCommand();

        createCmd.pacienteId = self.patient;

        if (self.medicamentoSeleccionado) {
            createCmd.medicamentoId = self.medicamentoSeleccionado.id;
        }

        if (self.f.fechaInicio.value) {
            createCmd.fechaInicio = self.dateTimeService.getDateTimeToSaveServer(self.f.fechaInicio.value);
        }

        if (self.f.fechaFin.value) {
            createCmd.fechaFin = self.dateTimeService.getDateTimeToSaveServer(self.f.fechaFin.value);
        }


        createCmd.periodo = self.f.periodo.value;
        createCmd.observaciones = self.f.observaciones.value;

        self.blockedDocument = true;

        self.service.createPatientMedication(createCmd)
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {
                self.notify.success(self.l('Catalogos.Patients.Medications.SuccessfulCreate'), self.l('Success'));

                self.close();
            });
    }

    prepareForm(): void {
        const self = this;

        self.form = self.formBuilder.group({
            codigoMedicamento: [null],
            medicamentoDesc: [null],
            periodo: [null],
            fechaInicio: [null],
            fechaFin: [null],
            observaciones: [null]
        });

        self.f.codigoMedicamento.disable();
        self.f.medicamentoDesc.disable();
    }

    changeDate(): void {
        const self = this;

        self.f.age.setValue(null);

        if (!self.f.eventDate.value) {
            return;
        }

        const f1 = self.dateTimeService.getDateToMoment(self.birthDate);
        const f2 = self.dateTimeService.getDateToMoment(self.f.eventDate.value as Date);

        self.f.age.setValue(f2 >= f1 ? f2.diff(f1, 'years') : null);
    }

    close(): void {
        const self = this;
        self.modalRef.close();
    }
}
